
    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/vpnpricecomparison",
      function () {
        return require("private-next-pages/vpnpricecomparison/index.tsx");
      }
    ]);
    if(module.hot) {
      module.hot.dispose(function () {
        window.__NEXT_P.push(["/vpnpricecomparison"])
      });
    }
  